export const AIS_REGISTER_ROLE_SECTION = 'app.ais3.doc.journal';

// URL
export const URL_DOWNLOAD_EXCEL = '/integration.module/register.documents/download/excel';
